import React, { Component } from "react";
import {
  UncontrolledDropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu
} from "reactstrap";

import { NavLink, withRouter, Link } from "react-router-dom";
import { connect } from "react-redux";
import {
  setContainerClassnames,
  clickOnMobileMenu,
  logoutUser
} from "../../redux/actions";

import {isDarkSwitchActive} from "../../constants/defaultValues";
import { MobileMenuIcon, MenuIcon } from "../../components/svg";
import TopnavEasyAccess from "./Topnav.EasyAccess";
import TopnavDarkSwitch from "./Topnav.DarkSwitch";

class TopNav extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isInFullScreen: false,
      member: JSON.parse(localStorage.getItem("member")),
      role: ""
    };
    switch (this.state.member.role) {
      case "Admin":
        this.state.role = "مدیر سایت";
        break;
      case "TransportationCompanyAdmin":
        this.state.role = "شرکت حمل و نقل";
        break;
     
      case "TransportationCompanyMember":
        this.state.role = "کاربر نمایندگی";
        break;
      case "Customer":
        this.state.role = "مشتری";
        break;
      
      case "Organization":
        this.state.role = "سازمان";
        break;
      case "LoadHallAdmin":
        this.state.role = "مدیر سالن";
        break;
      
        case "DriversAssociation":
            this.state.role = "انجمن رانندگان";
        break;
        case "AssociationTransportCompanies":
            this.state.role = "انجمن شركت های حمل و نقل";
        break;
     
        case "ProductOwnerAdmin":
            this.state.role = "صاحب کالا";
        break;
      
      default:
        this.state.role = "نوع کاربر مشخص نشده"
    }
  }

  isInFullScreen = () => {
    return (
      (document.fullscreenElement && document.fullscreenElement !== null) ||
      (document.webkitFullscreenElement &&
        document.webkitFullscreenElement !== null) ||
      (document.mozFullScreenElement &&
        document.mozFullScreenElement !== null) ||
      (document.msFullscreenElement && document.msFullscreenElement !== null)
    );
  };

  toggleFullScreen = () => {
    const isInFullScreen = this.isInFullScreen();

    var docElm = document.documentElement;
    if (!isInFullScreen) {
      if (docElm.requestFullscreen) {
        docElm.requestFullscreen();
      } else if (docElm.mozRequestFullScreen) {
        docElm.mozRequestFullScreen();
      } else if (docElm.webkitRequestFullScreen) {
        docElm.webkitRequestFullScreen();
      } else if (docElm.msRequestFullscreen) {
        docElm.msRequestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    }
    this.setState({
      isInFullScreen: !isInFullScreen
    });
  };

  handleLogout = () => {
    sessionStorage.clear();
    localStorage.clear();
    this.props.history.push('/Login');
  };

  menuButtonClick = (e, menuClickCount, containerClassnames) => {
    e.preventDefault();

    setTimeout(() => {
      var event = document.createEvent("HTMLEvents");
      event.initEvent("resize", false, false);
      window.dispatchEvent(event);
    }, 350);
    this.props.setContainerClassnames(
      ++menuClickCount,
      containerClassnames,
      this.props.selectedMenuHasSubItems
    );
  };
  mobileMenuButtonClick = (e, containerClassnames) => {
    e.preventDefault();
    this.props.clickOnMobileMenu(containerClassnames);
  };

  render() {
    const { containerClassnames, menuClickCount, notificationsCount } = this.props;
    const { member, role } = this.state;

    return (
      <nav className="navbar fixed-top">
        <div className="d-flex align-items-center navbar-left">
          <NavLink
            to="#"
            className="menu-button d-none d-md-block"
            onClick={e =>
              this.menuButtonClick(e, menuClickCount, containerClassnames)
            }
          >
            <MenuIcon />
            
          </NavLink>
          <NavLink
            to="#"
            className="menu-button-mobile d-xs-block d-sm-block d-md-none"
            onClick={e => this.mobileMenuButtonClick(e, containerClassnames)}
          >
            <MobileMenuIcon />
          </NavLink>
        </div>

        <a className="navbar-logo" href="/">
          <span className="logo d-none d-xs-block" />
          <span className="logo-mobile d-block d-xs-none" />
        </a>

        <div className="navbar-right d-flex justify-content-end align-items-center">
          {/* {isDarkSwitchActive && <TopnavDarkSwitch />} */}

          <div className="header-icons d-inline-block align-middle">

            {/* <TopnavEasyAccess /> */}

            {/* <div className="position-relative d-inline-block">
              <a href="./Notifications">
                <UncontrolledDropdown className="dropdown-menu-right">
                  <DropdownToggle
                      className="header-icon notificationButton"
                      color="empty"
                  >
                    <i className="simple-icon-bell" />
                    <span className="count">{notificationsCount}</span>
                  </DropdownToggle>
                </UncontrolledDropdown>
              </a>
            </div> */}
            {/*<TopnavNotifications notificationsCount={notificationsCount} />*/}
            {/* <button
              className="header-icon btn btn-empty d-none d-sm-inline-block"
              type="button"
              id="fullScreenButton"
              onClick={this.toggleFullScreen}
            >
              {this.state.isInFullScreen ? (
                <i className="simple-icon-size-actual d-block" />
              ) : (
                  <i className="simple-icon-size-fullscreen d-block" />
                )}
            </button> */}
          </div>

          <div className="user d-inline-block">
            <UncontrolledDropdown className="dropdown-menu-right">
              <DropdownToggle className="p-0 d-flex" color="empty">
                <div className="d-flex flex-column">
                  <span className="name mr-1 mb-1">{member.fullname}</span>
                  <span className="name mr-1">{role}</span>
                </div>
                <span>
                  <img alt="Profile" src="/assets/img/user.jpg" />
                </span>
              </DropdownToggle>
              <DropdownMenu className="mt-3" right>
                            <DropdownItem className="cursor-pointer" >  <NavLink  to="/Profile"  >
                               پروفایل 

                            </NavLink></DropdownItem>
               {/* <DropdownItem className="cursor-pointer">تغییر رمز عبور</DropdownItem>*/}
                <DropdownItem divider />
                <DropdownItem className="cursor-pointer" onClick={() => this.handleLogout()}>
                   خروج
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </div>
        </div>
      </nav>
    );
  }
}

const mapStateToProps = ({ menu }) => {
  const { containerClassnames, menuClickCount, selectedMenuHasSubItems } = menu;
  return {
    containerClassnames,
    menuClickCount,
    selectedMenuHasSubItems
  };
};

// export default TopNav;
// // export default injectIntl(
//   connect(
//     mapStateToProps,
//     { setContainerClassnames, clickOnMobileMenu, logoutUser }
//   )(TopNav)
// // );

export default withRouter(
    connect(
        mapStateToProps,
        {
          setContainerClassnames,
          clickOnMobileMenu,
          logoutUser
        }
    )(TopNav)
);
